import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-etis-candidate',
  templateUrl: './etis-candidate.component.html',
  styleUrls: ['./etis-candidate.component.scss']
})
export class EtisCandidateComponent implements OnInit {
  public candidateId='';
  public candidateProcUid='';
  res:any;
  vinNumber:any;
 
  constructor(private service: ApifirstService) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data) => {
      let c: any = data
      this.vinNumber = c.vin
 
    })
    
    this.service.candidateUidRef.subscribe((data) => {
      this.candidateId = data
    })
    
    this.service.candidateProcUid.subscribe((data) => {
      this.candidateProcUid = data
    })
   
    const req={
      "procUid":this.candidateProcUid,
      "uidRef":this.candidateId,
      "vin":this.vinNumber
    }
    // console.log(req)
    // this.service.renderWiringPage(req).subscribe(data=>{
    //  this.res= data;
    // })
  }
  // testHtml(){
  //   return this.res;
  // }

}
